module.exports = __webpack_public_path__ + "static/img/subcontract11.7b2b93ed.png";